import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "../../core/utils";

// Store
import { Actions } from "../../store/actions";

// Components
import { Button, Modal } from "antd";

export const UserModal = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const store = useSelector((state) => state?.Store);

  const [showUserModal, setShowUserModal] = useState(false);

  const logout = () => {
    dispatch(Actions.LogoutUser());
    history.push("/login/");
  };

  const close = () => {
    setShowUserModal(false);
  };

  return (
    <div className="user-modal">
      <button className="user-button" onClick={() => setShowUserModal(true)}>
        <i className="far fa-user"></i>
      </button>
      <Modal
        className="user-modal"
        visible={showUserModal}
        footer={null}
        centered={true}
        closable={false}
        destroyOnClose={true}>
        <div className="name">
          <div className="icon">
            <i className="far fa-user"></i>
          </div>
          <div className="text">
            <span>{`${store.user?.first_name} ${store.user?.last_name}`}</span>
          </div>
        </div>
        <div className="username mt-15">
          <div className="icon">
            <i className="far fa-lock"></i>
          </div>
          <div className="text">
            <span>{store.user?.username}</span>
          </div>
        </div>
        <div className="flex-row mt-15">
          <Button className="button-red ml-15" onClick={() => close()}>
            <i className="far fa-times"></i>
          </Button>
          <Button className="button-orange w-100" onClick={() => logout()}>
            خروج از اکانت
          </Button>
        </div>
      </Modal>
    </div>
  );
};
